import { colorSchemes } from './colorSchemes';
import { twMerge } from 'tailwind-merge';
import cx from 'classnames';
export var buttonStyle = function (scheme, disabled, small) {
    return cx("h-12 px-4 w-full rounded-default border\n                flex items-center justify-center font-semibold sm:w-fit-content\n                focus:ring-offset-cerulean-default focus:ring-offset-2 focus:ring-[0px] cursor-pointer", buttonSchemes(scheme), disabled && 'disabled:pointer-events-none', small && 'title-caption max-h-8');
};
export var buttonSchemes = function (scheme) {
    var baseColorScheme = colorSchemes(scheme);
    var finalStyle = '';
    switch (scheme) {
        case 'primary':
            finalStyle = "hover:bg-valhalla\n                          active:bg-mirage\n                          disabled:bg-alto";
            break;
        case 'secondary':
            finalStyle = "hover:bg-hover-grey hover:active:text-valhalla\n                          active:bg-snuff active:border-valhalla\n                          disabled:bg-white disabled:border-alto disabled:text-alto";
            break;
        case 'tertiary':
            finalStyle = "max-h-8\n                          hover:bg-hover-grey hover:active:text-valhalla\n                          active:bg-snuff\n                          disabled:text-alto";
            break;
        case 'icon':
            finalStyle = "hover:bg-alto\n                          active:bg-dove active:text-white\n                          disabled:text-alto disabled:bg-white";
            break;
        case 'icon-no-hover':
            finalStyle = 'disabled:text-alto disabled:bg-white';
            break;
        default:
            finalStyle = '';
            break;
    }
    return twMerge(baseColorScheme, finalStyle);
};
